<template>
  <div class="CapsuleToySuccess">
    <div class="abs headerIcon">
      <div 
        v-for="item in iconList" 
        :key="item.id + new Date().getTime()"
        class="on"
        :class="{'new': isNew(item.id)}"
      >
        <img :src="require(`@images/head/${item.iconId}.jpg`)" alt="">
      </div>
    </div>
    <!-- 扭到未拥有的头像 -->
    <div v-show="firstIconListLength > 0" class="abs capsuleToyButtom">
      <img src="@images/capsuleToySuccessTip.png" alt="" class="capsuleToyTip">
      <img src="@images/capsuleToySuccessConfirm.png" alt="" @click="successConfirm">
      <!--  -->
    </div>
    <!-- 扭到的全部已拥有 -->
    <div v-show="firstIconListLength === 0" class="abs capsuleToyButtom">
      <img src="@images/capsuleToyFinallyTip.png" alt="" class="capsuleToyTip">
      <img src="@images/capsuleToyFinallyConfirm.png" alt="" @click="finallyConfirm">
    </div>
  </div>
</template>

<script>
import { closePop, showPage } from '@/utils/common';

export default {
  data(){
    return {
      firstIconListLength: 0
    }
  },
  props: {
    iconList: {
      type: Array,
      default(){
        return []
      }
    },
    firstIconList: {
      type: Array,
      default(){
        return []
      }
    },
  },
  watch: {
    firstIconList(newValue){
      this.firstIconListLength = newValue.length;
    }
  },
  methods: {
    closePop,
    showPage,
    successConfirm(){
      this.closePop();
      this.showPage('HeadList');
    },
    finallyConfirm(){
      this.closePop();
    },
    isNew(id){
      return this.firstIconList?.find(item => item.iconId === id) ? true : false
    }
  }
}
</script>

<style scoped>
.CapsuleToySuccess{ width: 681px; height: 748px; background: url(@images/CapsuleToySuccess.png) no-repeat 0 0;}
.headerIcon{ top: 125px; left: 95px; display: flex; flex-wrap: wrap; justify-content: center; width: 515px;}
.headerIcon div{ margin: 7px 28px 26px 0 }
.capsuleToyButtom{ top: 477px; left: 49px; width: 602px; text-align: center;}
.capsuleToyTip{ margin-bottom: 35px;}
</style>